import React from 'react';

import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Editor from "@monaco-editor/react";

import { useAlert } from './AlertContext';
import { useMovie } from "../movie/MovieProvider";
import { useMovieSetter } from "../movie/MovieProvider";

export default function VEJSONEditorDialog(props) {

    const { showAlert } = useAlert();

    const movie = useMovie();
    const setMovie = useMovieSetter();

    const editorRef = React.useRef(null);

    const json = JSON.stringify(movie.movieObject, null, 2);
    const dialogTitle = "Edit template JSON";

    return (
        <Dialog open={props.openDialog} onClose={() => props.setOpenDialog(false)} fullWidth={true} maxWidth="md" >
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent sx={{ padding: "0" }} dividers={true}>
                <Editor
                    height="50vh"
                    defaultLanguage="json"
                    defaultValue={json}
                    onMount={handleEditorDidMount}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => props.setOpenDialog(false)}>Cancel</Button>
                <Button variant="contained" onClick={updateJSON}>Update JSON</Button>
            </DialogActions>
        </Dialog>
    );

    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
    }

    function updateJSON() {
        if (typeof props.updateHandler === "function") {
            try {
                // get the JSON string from the editor and parse it
                let json = JSON.parse(editorRef.current.getValue());

                // fix the movie
                // go through all the JSON object and remove any property name "id" that equals "@randomString"
                function removeIdProperty(obj) {
                    for (let property in obj) {
                        if (property === "id" && obj[property] === "@randomString") {
                            delete obj[property];
                        } else if (typeof obj[property] === "object") {
                            removeIdProperty(obj[property]);
                        }
                    }
                }
                removeIdProperty(json);

                props.updateHandler(json);
                props.setOpenDialog(false);
            }
            catch(error) {
                console.log("JSON syntax error: ", error);

                showAlert({
                    title: "Error parsing the JSON", 
                    message: [
                        "Sorry, there was an error parsing the JSON:",
                        "",
                        `<b>${error.toString()}</b>` 
                    ] 
                });
            }
        }
    }
}